const pickmeup = require("../pickmeup-custom");
const $ = require("jquery");

function init() {
    const language = $("html").attr("lang");
    
    $("[data-date-range-reservation]").each(function () {
        
        const $this = $(this);
        const fromSelector = $this.data("date-range-from"),
              toSelector = $this.data("date-range-to"),
              clearSelector = $this.data("date-range-clear");

        const fromInput = $(fromSelector),
              toInput = $(toSelector),
              clearButton = $(clearSelector);

        let defaultDate;

        if (fromInput.val() && toInput.val()) {
            defaultDate = [fromInput.val(), toInput.val()];
            clearButton.show();
        } else {
            defaultDate = null;
            clearButton.hide();
        }

        let separator = " - ";
        /*
        if (language == "en") {
            separator = " to ";
        }*/

        const pmu = pickmeup(this, {
            date: defaultDate,
            default_date: !!defaultDate,
            first_day: 0,
            //format: "Y-m-d",
            format: "d/m/Y",
            hide_on_select: true,
            locale: language,
            min: new Date(),
            mode: "range",
            separator: separator,
            title_format: "B Y"
        });
        
        this.addEventListener("pickmeup-change", function (e) {
            if (e.detail.formatted_date.length === 2) {
                fromInput.val(e.detail.formatted_date[0]);
                toInput.val(e.detail.formatted_date[1]);
                $this.trigger("change");

                clearButton.show();
            }
        });

        clearButton.on("click", function () {
            pmu.set_date(null);
            fromInput.val("");
            toInput.val("");
            $this.val("");

            clearButton.hide();
        });
    });
}

init();


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/ctrl-date-range-reservation/ctrl-date-range-reservation.chunk.js
// module id = 248
// module chunks = 0